module.exports = __webpack_public_path__ + "img/logo_ukr_white_mob.5a6c9082.png";